<template>
  <div>
    <div id="doc">
      <VueDocPreview :value="currentDocumento.documento + stgAccessKey" type="office" />
    </div>
  </div>
</template>

<script>
import VueDocPreview from "vue-doc-preview";
import config from "@/config";

export default {
  name: "ModalPreviewDocx",

  props: {
    currentDocumento: { type: Object },
  },

  data() {
    return {
      stgAccessKey: config.CD_STG_ACCESS_KEY
    };
  },

  components: {
    VueDocPreview,
  },
};
</script>

<style scoped>
#doc {
  width: 80%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
</style>
